import { PREMIUM, STANDARD, useAccountMode } from '../../useAccountMode';
import { getReward } from '../../../utils/helpers';
import { useTranslation } from '../../../translations';

export const useQuestPrize = (quest) => {
  const { prize, premiumPrize } = quest;

  const { mode: accountMode } = useAccountMode();
  const { t } = useTranslation();

  const mainPrize = {
    [STANDARD]: prize,
    [PREMIUM]: premiumPrize ?? prize,
  }[accountMode];

  const { value: rewardValue } = getReward(mainPrize ?? {}, t);

  const { value: premiumRewardValue } = getReward(premiumPrize ?? prize ?? {}, t);

  const mainReward = {
    [STANDARD]: rewardValue,
    [PREMIUM]: premiumRewardValue ?? rewardValue,
  }[accountMode];

  return {
    mainPrize,
    rewardValue,
    premiumRewardValue,
    mainReward,
  };
};
